<template>
  <div class="flex justify-center z-[100] relative pointer-events-none">
    <div
      class="fixed w-[90%] max-w-[400px] bottom-4 mx-auto pointer-events-none"
    >
      <div
        class="items-center ease-in-out gap-4 w-full h-full boxComponent pointer-events-auto bg-primary shadow-lg relative ripple p-5"
        @click="launchInstallation"
        :class="{
          'duration-[250ms] opacity-0 -bottom-[150px] scale-[0.95]':
            !installationComponentIsVisible,
          'duration-[400ms] opacity-100 top-0 scale-100':
            installationComponentIsVisible,
        }"
      >
        <div>
          <div class="flex items-center gap-4">
            <div class="aspect-scare w-[50px] min-w-[50px]">
              <!-- <img src="~@/assets/images/logo.png" class="w-full h-full" /> -->
            </div>
            <div>
              <div class="textComponent text-white font-bold text-md" bold>
                Profitez d'une meilleur expérience
              </div>
              <div class="pt-1"></div>
              <div class="textComponent text-sm font-bold text-[#C6CBCB]">
                IInstallez King Recharge pour Profiter d'une meileur experience
              </div>
            </div>
            <div class="ml-auto w-[40px] min-w-[40px] mr-2">
              <LottieComponent content="download" loop />
            </div>
          </div>
          <div class="py-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LottieComponent from '../utils/LottieComponent.vue'

export default {
  components: { LottieComponent },
  name: 'SplashComponent',
  data() {
    return {
      installationComponentIsVisible: false,
    }
  },
  mounted() {
    if (this.isInstalled()) {
      this.$Events.dispatchEvent('app_already_installed')
    } else this.installationComponentIsVisible = true
  },
  methods: {
    isInstalled() {
      const isInWebAppiOS = window.navigator.standalone === true
      const isInWebAppChrome = window.matchMedia(
        '(display-mode: standalone)',
      ).matches
      return isInWebAppiOS || isInWebAppChrome
    },
    async launchInstallation() {
      let isClient = false
      try {
        if (window) isClient = true
      } catch (error) {
        console.log(error)
      }
      if (!isClient) return
      if (!window.pwaInstallationPrompt) return this.installationFailed()
      pwaInstallationPrompt.prompt()
      this.$Events.dispatchEvent('user_preferences_setted', {
        pwaInstallationPromptLaunchedOnce: true,
      })

      const { outcome } = await pwaInstallationPrompt.userChoice
      // pwaInstallationPrompt = null;
      // this.installationComponentIsVisible = false;

      if (outcome === 'accepted') {
        this.$Events.dispatchEvent('user_preferences_setted', {
          pwaAnstallationPromptAccepted: true,
        })
        this.$Events.dispatchEvent('toast_notification', {
          type: 'success',
          title: 'Installation acceptée',
          body: "L'application sera installé sur votre téléphone",
        })
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      } else if (outcome === 'dismissed') {
        this.$Events.dispatchEvent('user_preferences_setted', {
          installationPromptRejected: true,
        })
        this.$Events.dispatchEvent('toast_notification', {
          type: 'warning',
          title: 'Installation refusée',
          body: "Veuillez réessayer l'installation pour utiliser l'application",
        })
      }
    },
    async installationFailed() {
      const userPreferences = await this.getPreferences()
      const promptLaunchedOnce =
        !!userPreferences?.pwaInstallationPromptLaunchedOnce
      const promptAccepted = !!userPreferences?.pwaAnstallationPromptAccepted
      const promptRejected = !!userPreferences?.installationPromptRejected
      if (promptLaunchedOnce)
        return onAppPromptAlreadyLaunched(promptAccepted, promptRejected)
      onAppPromptNotAvailable()
    },
    onAppPromptAlreadyLaunched(promptWasAccepted, promptWasRejected) {
      if (promptWasAccepted) {
        this.$Events.dispatchEvent('toast_notification', {
          type: 'info',
          title: 'Déjà installé',
          body: "L'installation de l'application a déjà été lancée une fois. Veuillez utiliser la version disponible sur votre téléphone",
        })
      } else if (promptWasRejected) {
        this.$Events.dispatchEvent('toast_notification', {
          type: 'info',
          title: 'Installation non autorisé',
          body: "Nous n'avons pas l'autorisation pour installer l'application. Essayez de l'installer manuellemnt depuis le menu en haut à droite du navigateur",
        })
      } else {
        return this.onAppPromptNotAvailable()
      }
      this.installationComponentIsVisible = false
    },
    onAppPromptNotAvailable() {
      this.$Events.dispatchEvent('toast_notification', {
        type: 'info',
        title: 'Veuillez patienter ou réactualiser',
        body: 'Veuillez patienter un moment puis réessayez ou installez manuellement dans le menu en haut à droite',
      })
    },
    async getPreferences() {
      const userPreferences = await new Promise(resolve => {
        this.$Events.sendDataRequest('userPreferences', resolve)
      })
      return userPreferences?.metaData || {}
    },
  },
}
</script>
